// extracted by mini-css-extract-plugin
module.exports = {"splash":"splash_splash__lP_0m"};